export default "__VITE_ASSET__C$ysoHfD__"